import React from 'react';

// A small uppercase label over a single value, in a bordered inset — for the one fact a
// page needs to show back to the user ("Account in use", "Reference"). Long values wrap
// rather than overflow, so an email or an id is safe on a phone.
//
// For several facts side by side use the DS definition card instead (.def-cols > .def-card >
// .def-row, see the Design System gallery), which is built for key/value grids.
export default function LabeledValueBox({ label = '', value = '', iconName = '', className = '' }) {
  return (
    <div className={('lvb-box ' + className).trim()}>
      {label ? <div className='lvb-label'>{label}</div> : null}
      <div className='lvb-value'>
        {iconName ? <i className={iconName} /> : null}
        <span>{value}</span>
      </div>
    </div>
  );
}
